import React, {Component} from "react";
import styles from "./HeaderPage.module.scss";

class HeaderPage extends Component {

    render() {
        const { title, description, picture } = this.props;
        return (
            <section className={` ${styles.fh5cohero} ${styles.fh5coheropage}`}  data-next="yes" style={{backgroundImage: `url(${picture})` }}>
                <div className={styles.fh5cooverlay}></div>
                <div className={` ${styles.fullheight} container`}>
                    <div className={`${styles.fh5cointro} ${styles.jsfullheight} d-flex justify-content-center`}>
                    <div className={`${styles.fh5cointrotext} d-flex  align-items-stretch justify-content-center`}>

                        <div className={`${styles.fh5cocenterposition} align-self-end`}>
                        <h2 className="animate-box">{title}</h2>
                        <h3 className="animate-box">{description}</h3>
                        </div>
                    </div>
                    </div>
                </div>

            </section>
        );
    }
}

export default HeaderPage;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderPage.jsx